import { render, staticRenderFns } from "./WorksList.vue?vue&type=template&id=0944f79f"
import script from "./WorksList.vue?vue&type=script&lang=js"
export * from "./WorksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports